export const translations = {
  en: {
    nav: {
      services: 'Services',
      monitoring: 'Monitoring',
      about: 'About',
      contact: 'Get in touch',
      langEn: 'EN',
      langEs: 'ES',
      langLabel: 'Language',
    },
    hero: {
      title: 'IT Solutions for Business Growth',
      subtitle:
        'We provide strategic technology consulting and solutions to help your business thrive in the digital landscape.',
      ctaPrimary: 'Get a Free Consultation',
      ctaSecondary: 'Explore Our Services',
    },
    services: {
      title: 'Our Services',
      subtitle:
        'Comprehensive IT consulting services tailored to meet your business needs and drive growth.',
      items: [
        {
          title: 'IT Infrastructure',
          description:
            'Design, implementation, and management of robust IT infrastructure solutions.',
        },
        {
          title: 'Cloud Solutions',
          description:
            'Strategic migration and management of cloud-based services and applications.',
        },
        {
          title: 'Cybersecurity',
          description:
            'Comprehensive security assessments and solutions to protect your business.',
        },
        {
          title: 'Managed IT Services',
          description: 'Proactive monitoring and management of your IT environment.',
        },
        {
          title: 'Business Intelligence',
          description:
            'Data analytics and reporting solutions to drive informed business decisions.',
        },
        {
          title: 'Digital Transformation',
          description:
            'Strategic guidance and implementation of digital transformation initiatives.',
        },
      ],
      learnMore: 'Learn more →',
      cybersecurityCta: 'See monitoring plans →',
    },
    monitoring: {
      badge: '24/7 CYBERSECURITY MONITORING',
      title: 'We monitor your business against cyberattacks.',
      subtitle:
        'We watch your servers around the clock, detect threats, and alert you to vulnerabilities so you can focus on your business.',
      perServer: '/ server / month',
      recommended: 'RECOMMENDED',
      extraHour: 'Additional hour:',
      footnote:
        'All plans include preferential rates for work outside the subscription (recovery, malware, migrations, and more).',
      cta: 'Talk to us about a plan',
      plans: [
        {
          name: 'Essential',
          price: 'USD 299',
          features: [
            '24/7 Monitoring',
            'Threat Detection',
            'Vulnerability Alerts',
          ],
          extraHour: 'USD 110',
        },
        {
          name: 'Professional',
          price: 'USD 400',
          features: [
            'Everything in Essential',
            'Security Updates',
            'Preventive Maintenance',
          ],
          extraHour: 'USD 80',
          featured: true,
        },
        {
          name: 'Enterprise',
          price: 'USD 599',
          features: [
            'Everything in Professional',
            'Advanced Security & Hardening',
            'Priority Support',
          ],
          extraHour: 'USD 60',
        },
      ],
    },
    about: {
      title: 'About TechRabbit',
      p1: 'TechRabbit has been at the forefront of IT consulting. Our elite team of experts collaborates seamlessly to solve complex technological challenges across various industries. With decades of combined experience, we pride ourselves on our multidisciplinary approach to problem-solving.',
      p2: 'We function as a cohesive unit of specialists, each bringing unique skills to the table. Our collaborative methodology ensures that every client benefits from our collective expertise, resulting in comprehensive solutions that drive meaningful business transformation.',
      features: [
        'Certified Experts',
        '24/7 Support',
        'Customized Solutions',
        'Proven Results',
      ],
      cta: 'Learn More About Us',
      imageAlt: 'Tech rabbits working on computers',
    },
    workflow: {
      title: 'How We Work',
      subtitle:
        'Our streamlined workflow is designed to deliver maximum value through our transparent $60/hr IT service model.',
      guaranteeTitle: '100% Satisfaction Guarantee',
      guaranteeLead: 'You only pay when the work is completed to your satisfaction.',
      guaranteeRest:
        'Our IT services are backed by our guarantee—if we don\'t deliver what we promise, you don\'t pay.',
      onDemandTitle: 'On-Demand IT Consulting with techrabbit',
      onDemandBody:
        'Access expert IT consultation exactly when you need it, for as long as you need it. With techrabbit\'s on-demand consulting service, you only pay for the time you use.',
      badges: [
        'No Retainer Fees',
        'No Minimum Hours',
        'Expert Assistance',
        'Pay As You Go',
      ],
      scenarios: [
        {
          title: 'Technical Emergencies',
          description:
            'Get immediate help when facing critical technical issues or unexpected outages.',
        },
        {
          title: 'Strategic Decisions',
          description:
            'Consult with our experts before making important technology investments or strategy changes.',
        },
        {
          title: 'System Optimizations',
          description:
            'Improve your existing infrastructure with targeted performance enhancements.',
        },
        {
          title: 'Security Assessments',
          description:
            'Get professional evaluation of your security posture and actionable recommendations.',
        },
      ],
      howTitle: 'How Our On-Demand Consulting Works',
      howSteps: [
        {
          lead: 'Book a session',
          body: ' — Schedule a consultation at a time that works for you, with as little as 1 hour notice for emergencies.',
        },
        {
          lead: 'Consult with experts',
          body: ' — Work directly with our specialized consultants who can quickly understand and address your needs.',
        },
        {
          lead: 'Implement solutions',
          body: ' — Receive actionable recommendations or direct assistance with implementation.',
        },
        {
          lead: 'Pay only for time used',
          body: ' — Be billed only for the actual consultation time at our standard $60/hr rate.',
        },
      ],
      bookCta: 'Book a Consultation Now',
      benefitsTitle: 'On-Demand Consulting Benefits',
      benefits: [
        'Access to specialized expertise without hiring full-time staff',
        'Flexible scheduling to fit your business needs',
        'Cost-effective with no long-term commitments',
        'Rapid response time for urgent technical issues',
        'Scale up or down based on project requirements',
        'Objective third-party perspective on your IT challenges',
      ],
      quote:
        '"techrabbit\'s on-demand consulting saved us thousands in unnecessary hardware costs. Their expert was able to optimize our existing infrastructure instead."',
      advantageTitle: 'Our $60/hr Service Advantage',
      pillars: [
        {
          title: 'IT Development',
          description:
            'Custom software solutions tailored to your unique business requirements',
        },
        {
          title: 'Infrastructure',
          description:
            'Secure, scalable technical foundations to support your business growth',
        },
        {
          title: 'Design',
          description:
            'Intuitive user experiences and interfaces that delight your customers',
        },
      ],
      rateTitle: 'Hourly Rate: $60',
      rateBody:
        'Our transparent hourly rate includes all three essential services—Development, Infrastructure, and Design.',
      rateBadges: [
        'Pay Only For Results',
        'Guaranteed Completion',
        'No Hidden Costs',
      ],
      tabAllocation: 'Service Allocation',
      tabCost: 'Cost Comparison',
      allocationTitle: '$60/hr IT Service Allocation',
      allocationSubtitle:
        'Our hourly rate includes equal coverage across all three core services',
      costTitle: 'Cost Efficiency Comparison',
      costSubtitle:
        'Our $60/hr rate vs traditional billing approach (relative costs)',
      costFooter: 'All three services included in our $60/hr service package',
      chartDev: 'IT Development',
      chartInfra: 'Infrastructure',
      chartDesign: 'Design',
      chartTraditional: 'Traditional Billing',
      chartOurRate: 'Our $60/hr Rate',
      processTitle: 'Our Process',
      steps: [
        {
          title: 'Consultation',
          description:
            'We begin with an in-depth discovery session to understand your business goals, technical requirements, and existing infrastructure.',
        },
        {
          title: 'Planning & Design',
          description:
            'Our team creates a comprehensive blueprint covering all aspects of your project, from UI/UX design to technical architecture.',
        },
        {
          title: 'Development',
          description:
            'Our developers build your solution using industry best practices and cutting-edge technologies that align with your business needs.',
        },
        {
          title: 'Infrastructure Setup',
          description:
            'We configure and optimize your technical infrastructure, ensuring security, scalability, and performance.',
        },
        {
          title: 'Testing & Launch',
          description:
            'Rigorous quality assurance testing is performed before we deploy your solution to production environments.',
        },
        {
          title: 'Ongoing Support',
          description:
            'We provide continued maintenance and support to ensure your systems remain secure, efficient, and up-to-date.',
        },
      ],
      paymentTitle: 'Our Payment Guarantee',
      paymentItems: [
        {
          title: 'No Upfront Payment',
          description:
            'We start working on your project without requiring any initial payment.',
        },
        {
          title: 'Pay Only For Results',
          description:
            'Only pay for the hours we work when the task is completed to your satisfaction.',
        },
        {
          title: 'Satisfaction Assured',
          description:
            'If you\'re not happy with our work, you don\'t pay. It\'s that simple.',
        },
      ],
      ctaTitle: 'Ready to Get Started?',
      ctaP1:
        'Our $60/hr IT services come with our satisfaction guarantee: you only pay if the work is completed successfully.',
      ctaP2:
        'Development, Infrastructure, and Design — professional IT support with no risk to you.',
      ctaButton: 'Schedule a Consultation',
    },
    contact: {
      title: 'Get In Touch',
      subtitle:
        'Ready to transform your IT setup? Tell us what you need — we only bill when the work is done to your satisfaction.',
      nextTitle: 'What happens next',
      nextSteps: [
        'We review your message and reply within one business day.',
        'Short discovery call to align on scope, timeline, and the $60/hr model.',
        'We start without upfront payment — you pay only for completed work you accept.',
      ],
      preferEmail: 'Prefer email?',
      name: 'Name',
      email: 'Email',
      message: 'Message',
      namePlaceholder: 'Your name',
      emailPlaceholder: 'Your email',
      messagePlaceholder: 'How can we help you?',
      send: 'Send Message',
      sending: 'Sending…',
      success: 'Thanks — we received your message and will get back to you soon.',
      errorFallback: 'Something went wrong',
    },
    footer: {
      company: 'Company',
      services: 'Services',
      legal: 'Legal',
      aboutUs: 'About Us',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      cookies: 'Cookie Policy',
      rights: 'All rights reserved.',
    },
    whatsapp: {
      label: 'Chat on WhatsApp',
    },
    meta: {
      title: 'TechRabbit - IT Services & Consulting',
      description:
        'TechRabbit - IT Services and Consulting with Guaranteed Results. Pay only when the work is completed to your satisfaction.',
    },
  },
  es: {
    nav: {
      services: 'Servicios',
      monitoring: 'Monitoreo',
      about: 'Nosotros',
      contact: 'Contacto',
      langEn: 'EN',
      langEs: 'ES',
      langLabel: 'Idioma',
    },
    hero: {
      title: 'Soluciones de TI para el crecimiento de tu negocio',
      subtitle:
        'Ofrecemos consultoría tecnológica estratégica y soluciones para que tu empresa prospere en el entorno digital.',
      ctaPrimary: 'Consulta gratuita',
      ctaSecondary: 'Ver nuestros servicios',
    },
    services: {
      title: 'Nuestros servicios',
      subtitle:
        'Servicios de consultoría en TI pensados para las necesidades de tu negocio y para impulsar el crecimiento.',
      items: [
        {
          title: 'Infraestructura de TI',
          description:
            'Diseño, implementación y gestión de soluciones de infraestructura robustas.',
        },
        {
          title: 'Soluciones en la nube',
          description:
            'Migración estratégica y gestión de servicios y aplicaciones en la nube.',
        },
        {
          title: 'Ciberseguridad',
          description:
            'Evaluaciones de seguridad y soluciones integrales para proteger tu negocio.',
        },
        {
          title: 'Servicios de TI gestionados',
          description:
            'Monitoreo y gestión proactiva de tu entorno tecnológico.',
        },
        {
          title: 'Business Intelligence',
          description:
            'Analítica de datos e informes para tomar decisiones de negocio informadas.',
        },
        {
          title: 'Transformación digital',
          description:
            'Guía estratégica e implementación de iniciativas de transformación digital.',
        },
      ],
      learnMore: 'Ver más →',
      cybersecurityCta: 'Ver planes de monitoreo →',
    },
    monitoring: {
      badge: 'MONITOREO DE CIBERSEGURIDAD 24/7',
      title: 'Monitoreamos tu negocio contra ciberataques.',
      subtitle:
        'Vigilamos tus servidores las 24 horas, detectamos amenazas y te alertamos sobre vulnerabilidades para que vos te dedicás a tu negocio.',
      perServer: '/ servidor / mes',
      recommended: 'RECOMENDADO',
      extraHour: 'Hora adicional:',
      footnote:
        'Todos los planes incluyen tarifas preferenciales para intervenciones fuera de la suscripción (recuperación, malware, migraciones, etc.).',
      cta: 'Hablemos de un plan',
      plans: [
        {
          name: 'Essential',
          price: 'USD 299',
          features: [
            'Monitoreo 24/7',
            'Detección de amenazas',
            'Alertas de vulnerabilidades',
          ],
          extraHour: 'USD 110',
        },
        {
          name: 'Professional',
          price: 'USD 400',
          features: [
            'Todo lo de Essential',
            'Actualizaciones de seguridad',
            'Mantenimiento preventivo',
          ],
          extraHour: 'USD 80',
          featured: true,
        },
        {
          name: 'Enterprise',
          price: 'USD 599',
          features: [
            'Todo lo de Professional',
            'Seguridad avanzada y hardening',
            'Atención prioritaria',
          ],
          extraHour: 'USD 60',
        },
      ],
    },
    about: {
      title: 'Sobre TechRabbit',
      p1: 'TechRabbit está a la vanguardia de la consultoría en TI. Nuestro equipo de expertos colabora de forma fluida para resolver desafíos tecnológicos complejos en distintas industrias. Con décadas de experiencia combinada, nos enorgullece nuestro enfoque multidisciplinario para resolver problemas.',
      p2: 'Funcionamos como una unidad cohesiva de especialistas, cada uno con habilidades únicas. Nuestra metodología colaborativa asegura que cada cliente se beneficie de nuestra experiencia colectiva, con soluciones integrales que impulsan una transformación real del negocio.',
      features: [
        'Expertos certificados',
        'Soporte 24/7',
        'Soluciones a medida',
        'Resultados comprobados',
      ],
      cta: 'Conocé más sobre nosotros',
      imageAlt: 'Conejos tecnológicos trabajando en computadoras',
    },
    workflow: {
      title: 'Cómo trabajamos',
      subtitle:
        'Nuestro flujo de trabajo está pensado para maximizar el valor con un modelo transparente de US$60/hora.',
      guaranteeTitle: 'Garantía de satisfacción 100%',
      guaranteeLead: 'Solo pagás cuando el trabajo está terminado a tu satisfacción.',
      guaranteeRest:
        'Nuestros servicios de TI están respaldados por esta garantía: si no cumplimos lo prometido, no pagás.',
      onDemandTitle: 'Consultoría de TI bajo demanda con techrabbit',
      onDemandBody:
        'Accedé a consultoría experta exactamente cuando la necesitás y por el tiempo que la necesitás. Con el servicio bajo demanda de techrabbit, solo pagás el tiempo que usás.',
      badges: [
        'Sin retainer',
        'Sin horas mínimas',
        'Asistencia experta',
        'Pagá por uso',
      ],
      scenarios: [
        {
          title: 'Emergencias técnicas',
          description:
            'Obtené ayuda inmediata ante problemas críticos o caídas inesperadas.',
        },
        {
          title: 'Decisiones estratégicas',
          description:
            'Consultá con nuestros expertos antes de inversiones tecnológicas o cambios de estrategia.',
        },
        {
          title: 'Optimización de sistemas',
          description:
            'Mejorá tu infraestructura actual con mejoras de rendimiento puntuales.',
        },
        {
          title: 'Evaluaciones de seguridad',
          description:
            'Evaluación profesional de tu postura de seguridad y recomendaciones accionables.',
        },
      ],
      howTitle: 'Cómo funciona la consultoría bajo demanda',
      howSteps: [
        {
          lead: 'Reservá una sesión',
          body: ' — Agendá una consulta en el horario que te sirva, con tan solo 1 hora de anticipación en emergencias.',
        },
        {
          lead: 'Consultá con expertos',
          body: ' — Trabajá directo con consultores especializados que entienden y resuelven tus necesidades rápido.',
        },
        {
          lead: 'Implementá soluciones',
          body: ' — Recibí recomendaciones accionables o asistencia directa en la implementación.',
        },
        {
          lead: 'Pagá solo el tiempo usado',
          body: ' — Se factura únicamente el tiempo real de consulta a nuestra tarifa estándar de US$60/hora.',
        },
      ],
      bookCta: 'Reservar una consulta',
      benefitsTitle: 'Beneficios de la consultoría bajo demanda',
      benefits: [
        'Acceso a expertise especializado sin contratar personal full-time',
        'Agenda flexible según las necesidades de tu negocio',
        'Rentable, sin compromisos a largo plazo',
        'Respuesta rápida ante problemas técnicos urgentes',
        'Escalá hacia arriba o abajo según el proyecto',
        'Perspectiva objetiva de terceros sobre tus desafíos de TI',
      ],
      quote:
        '"La consultoría bajo demanda de techrabbit nos ahorró miles en hardware innecesario. Su experto optimizó la infraestructura que ya teníamos."',
      advantageTitle: 'La ventaja de nuestro servicio a US$60/hora',
      pillars: [
        {
          title: 'Desarrollo de TI',
          description:
            'Soluciones de software a medida según los requisitos de tu negocio',
        },
        {
          title: 'Infraestructura',
          description:
            'Bases técnicas seguras y escalables para acompañar tu crecimiento',
        },
        {
          title: 'Diseño',
          description:
            'Experiencias e interfaces intuitivas que deleitan a tus clientes',
        },
      ],
      rateTitle: 'Tarifa por hora: US$60',
      rateBody:
        'Nuestra tarifa transparente incluye los tres servicios esenciales: Desarrollo, Infraestructura y Diseño.',
      rateBadges: [
        'Pagás solo por resultados',
        'Finalización garantizada',
        'Sin costos ocultos',
      ],
      tabAllocation: 'Asignación del servicio',
      tabCost: 'Comparación de costos',
      allocationTitle: 'Asignación del servicio a US$60/hora',
      allocationSubtitle:
        'Nuestra tarifa horaria incluye cobertura equitativa de los tres servicios principales',
      costTitle: 'Comparación de eficiencia de costos',
      costSubtitle:
        'Nuestra tarifa de US$60/hora vs. facturación tradicional (costos relativos)',
      costFooter: 'Los tres servicios incluidos en nuestro paquete de US$60/hora',
      chartDev: 'Desarrollo de TI',
      chartInfra: 'Infraestructura',
      chartDesign: 'Diseño',
      chartTraditional: 'Facturación tradicional',
      chartOurRate: 'Nuestra tarifa US$60/h',
      processTitle: 'Nuestro proceso',
      steps: [
        {
          title: 'Consulta',
          description:
            'Empezamos con una sesión de descubrimiento para entender tus objetivos, requisitos técnicos e infraestructura actual.',
        },
        {
          title: 'Planificación y diseño',
          description:
            'Creamos un plan integral que cubre todos los aspectos del proyecto, desde UI/UX hasta la arquitectura técnica.',
        },
        {
          title: 'Desarrollo',
          description:
            'Construimos tu solución con buenas prácticas de la industria y tecnologías alineadas a tu negocio.',
        },
        {
          title: 'Configuración de infraestructura',
          description:
            'Configuramos y optimizamos tu infraestructura técnica, priorizando seguridad, escalabilidad y rendimiento.',
        },
        {
          title: 'Pruebas y lanzamiento',
          description:
            'Realizamos pruebas rigurosas de calidad antes de desplegar la solución en producción.',
        },
        {
          title: 'Soporte continuo',
          description:
            'Brindamos mantenimiento y soporte continuo para que tus sistemas sigan seguros, eficientes y actualizados.',
        },
      ],
      paymentTitle: 'Nuestra garantía de pago',
      paymentItems: [
        {
          title: 'Sin pago inicial',
          description:
            'Empezamos a trabajar en tu proyecto sin pedir un pago por adelantado.',
        },
        {
          title: 'Pagás solo por resultados',
          description:
            'Solo pagás las horas trabajadas cuando la tarea está completa a tu satisfacción.',
        },
        {
          title: 'Satisfacción asegurada',
          description:
            'Si no estás conforme con el trabajo, no pagás. Así de simple.',
        },
      ],
      ctaTitle: '¿Listo para empezar?',
      ctaP1:
        'Nuestros servicios de TI a US$60/hora incluyen garantía de satisfacción: solo pagás si el trabajo se completa con éxito.',
      ctaP2:
        'Desarrollo, infraestructura y diseño — soporte profesional de TI sin riesgo para vos.',
      ctaButton: 'Agendar una consulta',
    },
    contact: {
      title: 'Contacto',
      subtitle:
        '¿Listo para transformar tu infraestructura de TI? Contanos qué necesitás — solo facturamos cuando el trabajo está hecho a tu satisfacción.',
      nextTitle: 'Qué sigue',
      nextSteps: [
        'Revisamos tu mensaje y respondemos dentro de un día hábil.',
        'Una llamada breve de discovery para alinear alcance, tiempos y el modelo de US$60/hora.',
        'Empezamos sin pago inicial — solo pagás el trabajo completado que aceptás.',
      ],
      preferEmail: '¿Preferís email?',
      name: 'Nombre',
      email: 'Email',
      message: 'Mensaje',
      namePlaceholder: 'Tu nombre',
      emailPlaceholder: 'Tu email',
      messagePlaceholder: '¿En qué podemos ayudarte?',
      send: 'Enviar mensaje',
      sending: 'Enviando…',
      success: 'Gracias — recibimos tu mensaje y te responderemos pronto.',
      errorFallback: 'Algo salió mal',
    },
    footer: {
      company: 'Empresa',
      services: 'Servicios',
      legal: 'Legal',
      aboutUs: 'Sobre nosotros',
      privacy: 'Política de privacidad',
      terms: 'Términos de servicio',
      cookies: 'Política de cookies',
      rights: 'Todos los derechos reservados.',
    },
    whatsapp: {
      label: 'Escribinos por WhatsApp',
    },
    meta: {
      title: 'TechRabbit - Servicios y consultoría de TI',
      description:
        'TechRabbit - Servicios y consultoría de TI con resultados garantizados. Solo pagás cuando el trabajo está completo a tu satisfacción.',
    },
  },
};
